module.exports = __webpack_public_path__ + "static/media/cf.3530456f.webp";